module.exports = __webpack_public_path__ + "img/logo_3.384f8ee3.jpg";